import React from 'react'
import { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import Loader from '../../components/ClinicLoader'
import { updateLocalStorage } from '../../../stores/Clinic/Auth'

const SlotsRedirection = () => {
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(location.search)
    const id = urlSearchParams.get('id') || ''
    const token = urlSearchParams.get('token') || ''

    if (id.length > 0 && token.length > 0) {
      localStorage.setItem('clinic_user_id', id)
      localStorage.setItem('clinic_auth_key', token)

      updateLocalStorage({
        id_token: token,
        hospital_details: { user_id: id }
      })
        .then(() => {
          history.replace('/clinic/schedule')
        })
        .catch(console.error)
    } else alert('Bad Redirection')
  }, [location.search, history])

  return (
    <Loader
      type="ThreeDots"
      color="#114ebd"
      height={75}
      width={75}
      timeout={0}
      style={{ marginLeft: '50%' }}
    />
  )
}

export default SlotsRedirection
